import script from "./footer-dark.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-dark.vue?vue&type=script&setup=true&lang=js"

import "./footer-dark.vue?vue&type=style&index=0&id=2d3b60ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3b60ab"]])

export default __exports__